<template>
  <vab-row class="row_box">
    <vab-col :span="4" class="title_box">
      依頼先
      <i class="red">*</i>
    </vab-col>
    <vab-col :span="20" class="word_box">
      <div class="en_box flex_colum">
        <en-item
          v-for="(item, index) in list"
          :key="index"
          @click="del(index)"
        ></en-item>
      </div>
      <slot name="btn">
        <div class="flex_start mt12">
          <vab-button :btn-list="btnList" class="no_margin"></vab-button>
        </div>
      </slot>
    </vab-col>
    <notify-add-company
      ref="notifyCompany"
      @setData="setData"
    ></notify-add-company>
  </vab-row>
</template>

<script>
  export default {
    name: 'VabEntrust',
    data() {
      return {
        list: [],
        btnList: [
          {
            name: '依頼先を追加',
            type: 'plain',
            hover: '#0171EE',
            defaultColor: '#0060C2',
            hidden: false,
            click: () => {
              this.$refs.notifyCompany.initData()
            },
          },
        ],
      }
    },
    methods: {
      setData(data) {
        this.list = [...this.list, ...data]
      },
      del(index) {
        this.list.splice(index, 1)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .en_box {
    flex-wrap: wrap;
  }
</style>
